import {Injectable, TemplateRef} from '@angular/core';

/**
 * Configuration service for the NgbDropdown directive.
 * You can inject this service, typically in your root component, and customize the values of its properties in
 * order to provide default values for all the dropdowns used in the application.
 */
@Injectable()
export class NgbDropdownConfig {
  up = false;
  autoClose = true;
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/dropdown/dropdown-config.ts